import { AppState } from 'core/redux/reducers';
import { selectTranslator } from 'core/redux/features/languages/trans';
// import { hot } from 'react-hot-loader/root'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { actions } from 'core/redux/features/booking';
import StepForm from 'Components/Checkout/StepForm';
import { selectActiveProduct } from '../../../core/redux/features/products/reducers/products';
import { IProduct } from '../../../core/redux/features/products/types';

const mapStateToProps = (state: AppState) => ({
  trans: selectTranslator(state),
  loading: state.booking.loading,
  stepData: state.booking.form_data,
  steps: state.booking.steps,
  activeStepIndex: state.booking.activeStepIndex,
  deviceType: state.deviceType,
  product: selectActiveProduct(state) as IProduct | null,
});

const mapDispatchToProps = {
  onSubmitFormStep: actions.formSubmit,
  setActiveStepIndex: actions.setActiveStepIndex,
};

// const FormStepRoot =
//   process.env.NODE_ENV !== 'production' ? hot(StepForm) : StepForm;

const FormStepContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StepForm);
export default withRouter(FormStepContainer);
